import { Box, Paper, Typography } from "@mui/material";
import { globalStyles } from "../styles/GlobalStyles";
import { useForm } from "react-hook-form";
import InputText from "../components/InputText";
import Button from "../components/Button";
import { useNavigate } from "react-router";
import useRecoverUsernameMutation from "../modules/authModule/hooks/useRecoverUsernameMutation";
import { RECOVER_USERNAME_REQUEST } from "../modules/authModule/types/RequestTypes";
import { getEmailValidationRules } from "../helpers/formValidationRules";
import { useTranslation } from "react-i18next";

const RecoverUsername = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { control, watch, handleSubmit, reset } =
    useForm<RECOVER_USERNAME_REQUEST>({
      defaultValues: {
        email: "",
      },
    });

  const {
    mutate: recoverUsernameMutate,
    isSuccess,
    isPending,
  } = useRecoverUsernameMutation(reset);

  return (
    <Box sx={globalStyles.colCenter}>
      <Paper
        sx={{
          padding: 2,
          width: 412,
          borderRadius: 4,
        }}
      >
        {!isSuccess ? (
          <>
            <Typography
              textTransform="capitalize"
              fontWeight={700}
              variant="h5"
            >
              {t("Recover_username")}
            </Typography>
            <Typography mt={1}>{t("Recover_username_subheading")}</Typography>
            <form
              onSubmit={handleSubmit((val) => {
                recoverUsernameMutate(val);
              })}
            >
              <InputText
                isLabelDefaultBehaviour
                name="email"
                control={control}
                label={t("Email_address")}
                rules={getEmailValidationRules()}
                //@ts-ignore
                color="custom.foreground.primary"
                sx={{
                  my: 3,
                }}
              />

              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={!watch("email") || isPending}
                sx={{
                  mb: 3,
                  backgroundColor: "custom.background.brand",
                  textTransform: "none",
                  fontSize: 16,
                }}
              >
                {t("Submit")}
              </Button>
              <Button
                disabled={isPending}
                onClick={() => navigate(-1)}
                fullWidth
                sx={{
                  textTransform: "none",
                  fontSize: 16,
                  color: "custom.foreground.secondary",
                }}
              >
                {t("Cancel_and_go_back")}
              </Button>
            </form>
          </>
        ) : (
          <>
            <Typography
              textTransform="capitalize"
              fontWeight={700}
              variant="h5"
            >
              {t("Recovery_Request_Submitted")}
            </Typography>
            <Typography mt={1} mb={3}>
              {t("Username_Recover_Message")}
            </Typography>
            <Button
              disabled={isPending}
              onClick={() => navigate(-1)}
              fullWidth
              sx={{
                textTransform: "none",
                fontSize: 16,
                color: "custom.foreground.secondary",
              }}
            >
              {t("Back_to_Login")}
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default RecoverUsername;
